import React from "react";
import { Box } from "@mui/material";

import { STATUS_COLORS_OPACITY } from "../../../../constants";

interface IProps {
  entriesId: number;
  multiplePasses?: boolean;
}
export const getEntriesIdWithPrefix = (entriesId: number, multiplePasses = false): string =>
  `EFT-${entriesId}`;

const EntriesIdWithPrefix: React.FC<IProps> = ({ entriesId, multiplePasses }) => (
  <Box
    component="span"
    sx={{
      ...(multiplePasses && {
        backgroundColor: STATUS_COLORS_OPACITY.pastelPink,
        padding: "2px",
        borderRadius: "3px",
      }),
    }}
  >
    {entriesId && getEntriesIdWithPrefix(entriesId, multiplePasses)}
  </Box>
);

export default EntriesIdWithPrefix;
